// upTime arrives in milliseconds; the column is seconds.
const uptimeSeconds = (milliseconds) =>
  milliseconds == null ? undefined : Math.floor(milliseconds / 1000)

// The device reports these voltages in millivolts. Rounding to whole mV before
// dividing keeps 12345 mV printing as 12.345 V rather than 12.344999999999999.
const milliVoltsToVolts = (value) => (value != null ? Math.round(value) / 1000 : undefined)

const onOff = (value) => (value === undefined ? undefined : value === 1 ? 'ON' : 'OFF')

// Values here are unit-free — the unit is stated once in the column header
// instead (see HistoricalData's UNIT_BY_KEY).
export const mapDeviceHistoryToRows = (history) => {
  if (!Array.isArray(history)) return []
  return history
    .map((snap) => {
      const { deviceInfo = {}, networkData = {}, systemData = {}, metricsData = {}, locationData = {} } = snap
      const gps = Array.isArray(locationData.gps) ? locationData.gps : []
      const nwStrength = Array.isArray(networkData.nwStrength) ? networkData.nwStrength : []
      const connectedSrvr = Array.isArray(systemData.connectedSrvr) ? systemData.connectedSrvr : []
      return {
        epochMs: new Date(snap.ts).getTime(),
        timestamp: new Date(snap.ts).toLocaleString(),

        'deviceInfo.upTime': uptimeSeconds(deviceInfo.upTime),
        'deviceInfo.iotVolt': milliVoltsToVolts(deviceInfo.iotVolt),
        'deviceInfo.chipTemp': deviceInfo.chipTemp,
        'deviceInfo.ramUsed': deviceInfo.ramUsed,
        'deviceInfo.simNo': deviceInfo.simNo,
        'deviceInfo.aFlashSize': deviceInfo.aFlashSize,
        'networkData.nwOperName': networkData.nwOperName,
        'networkData.nwStrength[0]': nwStrength[0],
        'networkData.nwStrength[1]': nwStrength[1],
        'networkData.nwStrength[2]': nwStrength[2],
        'networkData.nwStrength[3]': nwStrength[3],
        'locationData.gps[0]': gps[0],
        'locationData.gps[1]': gps[1],
        'locationData.gps[2]': gps[2],
        'locationData.gps[3]': gps[3],
        'locationData.gps[4]': gps[4],
        'locationData.gps[5]': gps[5],
        'locationData.gps[6]': gps[6],
        'locationData.gps[7]': gps[7],
        'locationData.gps[8]': gps[8],
        'locationData.gps[9]': gps[9],
        'locationData.gps[10]': gps[10],
        'locationData.gps[11]': gps[11],
        'locationData.gps[12]': gps[12],
        'locationData.gps[13]': gps[13],
        'systemData.activityStatus': onOff(systemData.activityStatus),
        'systemData.tripStatus': onOff(systemData.tripStatus),
        'systemData.psmStatus': onOff(systemData.psmStatus),
        'systemData.efficiencyMode': onOff(systemData.efficiencyMode),
        'systemData.immobStatus': onOff(systemData.immobStatus),
        'systemData.odoMeter': systemData.odoMeter != null && !Number.isNaN(Number(systemData.odoMeter))
          ? Number(systemData.odoMeter).toFixed(2)
          : undefined,
        'systemData.tripMeter': systemData.tripMeter,
        'systemData.connectedSrvr[1]': connectedSrvr[0],
        'systemData.connectedSrvr[2]': connectedSrvr[1],
        'metricsData.bootCnt': metricsData.bootCnt,
        'metricsData.uartErr': metricsData.uartErr,
        'metricsData.canErr': metricsData.canErr,
        'metricsData.mqttErrCnt': metricsData.mqttErrCnt,
        'metricsData.nwJamStatus': onOff(metricsData.nwJamStatus),
        'metricsData.rwErrCnt': metricsData.rwErrCnt,
        'metricsData.selfRstCnt': metricsData.selfRstCnt,
        'metricsData.simErrCnt': metricsData.simErrCnt,
        // Was rendered as "V" straight off the wire, but the device sends this
        // in millivolts like iotVolt — the old column read 12345 V.
        'metricsData.supplyMinValue': milliVoltsToVolts(metricsData.supplyMinValue),
        'metricsData.supplyUvCnt': metricsData.supplyUvCnt,
        'metricsData.totDataCnsmd': metricsData.totDataCnsmd,
        'metricsData.tripDistance': metricsData.tripDistance,
        'metricsData.assertFailCnt': metricsData.assertFailCnt,
        'metricsData.gpsErrCount': metricsData.gpsErrCount,
        'metricsData.gpsOutSec': metricsData.gpsOutSec,
        'metricsData.intrntErrCnt': metricsData.intrntErrCnt,
      }
    })
    .sort((a, b) => b.epochMs - a.epochMs)
}
